var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-section',{attrs:{"id":"agreement","headline":this.$t('form.agreement.headline')}},[_c('textfield',{attrs:{"id":"agreement_description","label":_vm.$t('form.agreement.description.label'),"placeholder":_vm.$t('form.agreement.description.placeholder'),"isRequired":""},on:{"focus":function($event){return _vm.scrollTo('#agreement_contract')}},model:{value:(_vm.agreement.description),callback:function ($$v) {_vm.$set(_vm.agreement, "description", $$v)},expression:"agreement.description"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/hemmelig/components/form/Agreement.vue?vue&type=template&id=4bc514be&
// module id = null
// module chunks = 